import { defineComponent as _defineComponent } from 'vue'
import UpcomingMeeting from "../components/upcomingMeeting.vue"
import Loader from '@/components/loader.vue';
import { useRouter } from 'vue-router';
import {onBeforeMount, onMounted, ref, computed} from 'vue'
import { Meetings, FinancialUserspaces, InviteLinks } from '@busy-human/opt-library';
import { query, where} from "firebase/firestore";


import meetingPopup from "@/components/meeting-details/meeting-details.vue"
import changeMeeting from "@/components/meeting-details/cancel-meeting.vue"
import { DataInstance } from "@busy-human/gearbox";
import { useUserspace } from "@/store/userspace";
import { useInvites } from "@/store/invites";
import { useMeetings } from "@/store/meetings";

export default /*#__PURE__*/_defineComponent({
  __name: 'home',
  setup(__props, { expose }) {
  expose();

var moment = require('moment'); // require

const selectedMeeting = ref<DataInstance<Meetings.Model> | null>(null);
const showConfirm = ref(false)
const showPopup = ref(false)
const noScroll = ref<boolean>(false)


const router = useRouter();

const goTo = (path: string, hash?: string) =>{
    let route:any = {path:path}
    if(hash)
        route['hash'] = hash
    router.push(route)
}

const allMeetings = computed<DataInstance<Meetings.Model>[]>(() => useMeetings().list)
const invites = useInvites();
const allInvites = computed<DataInstance<InviteLinks.Model>[]>(() => invites.links);
const showWelcome = computed(() => !(allInvites.value.length > 1 || allMeetings.value.length))

const showFirstInvite = computed(() => allInvites.value.length && allMeetings.value.length === 1)

// const meetingsLoading = ref(false)

const userspace = useUserspace();
const user = computed(() => userspace.user);

const balance = computed(() => {
    return FinancialUserspaces.eventualBalance(userspace.financial);
});

const scheduledCount = computed(()=>{
    let scheduled = 0;
    let allMeetingsCopy = [...allMeetings.value]
    allMeetingsCopy.forEach(meeting =>{
        if( meeting.status === Meetings.MeetingStatus.scheduled || 
            meeting.status === Meetings.MeetingStatus.meetingStarted || 
            meeting.status === Meetings.MeetingStatus.meetingEnded || 
            (meeting.status === Meetings.MeetingStatus.collectorConfirmed && meeting?.payer == userspace.uid) || 
            (meeting.status === Meetings.MeetingStatus.payerConfirmed && meeting?.collector == userspace.uid))
            scheduled++
    })
    return scheduled
})

const heldCount = computed(()=>{
    let held = 0;
    let allMeetingsCopy = [...allMeetings.value]
    allMeetingsCopy.forEach(meeting =>{
        if( (meeting.status === Meetings.MeetingStatus.collectorConfirmed && meeting?.collector == userspace.uid) || 
            (meeting.status === Meetings.MeetingStatus.payerConfirmed && meeting?.payer == userspace.uid) ||
            meeting.status === Meetings.MeetingStatus.fullyConfirmed ||
            meeting.status === Meetings.MeetingStatus.adminConfirmed ||
            meeting.status === Meetings.MeetingStatus.contested )
            held++
    })
    return held
})

const currentMeetings = computed(()=>{
    let currentMeetings: DataInstance<Meetings.Model>[] = []
    let allMeetingsCopy = [...allMeetings.value]
    currentMeetings = allMeetingsCopy.filter(meeting =>{
        return meeting.status == Meetings.MeetingStatus.meetingStarted
    })
    timeSortMeetings(currentMeetings)
    return currentMeetings.splice(0, 1)
})

const failingPaymentMeetings = computed(()=>{
    let failingMeetings: DataInstance<Meetings.Model>[] = []
    let allMeetingsCopy = [...allMeetings.value]
    failingMeetings = allMeetingsCopy.filter(meeting =>{

        return meeting?.paymentStatus == 'failed' && meeting?.payer == userspace.uid
    })
    timeSortMeetings(failingMeetings)
    return failingMeetings.splice(0, 3)
})

const scheduledMeetings = computed(()=>{
    let meetingsToday: DataInstance<Meetings.Model>[] = []
    let today = new Date(Date.now())
    let allMeetingsCopy = [...allMeetings.value]
    meetingsToday = allMeetingsCopy.filter(meeting =>{
        return (today <= new Date(meeting.startTime) && meeting.status === Meetings.MeetingStatus.scheduled)
    })
    timeSortMeetings(meetingsToday)
    return meetingsToday.splice(0, 3)
})

//Show the Confirm Meeting popup for these
const payerConfirmableMeetings = computed(()=>{
    let meetingsPrevious: DataInstance<Meetings.Model>[] = []
    let today = moment(Date.now())

    let allMeetingsCopy = [...allMeetings.value]
    meetingsPrevious = allMeetingsCopy.filter(meeting =>{
        let meetingDate = new Date(meeting.startTime)
        return (
            today.isAfter(meetingDate) && 
            meeting?.payer == userspace.uid && 
            ((meeting.status === Meetings.MeetingStatus.meetingEnded) || (meeting.status === Meetings.MeetingStatus.collectorConfirmed)))
    })

    if(meetingsPrevious.length > 0) showConfirm.value = true

    timeSortMeetings(meetingsPrevious)

    return meetingsPrevious.splice(0,1)
})

const confirmableMeetings = computed(()=>{
    let confirmableMeetings: DataInstance<Meetings.Model>[] = []
    let today = moment(Date.now())

    let allMeetingsCopy = [...allMeetings.value]
    confirmableMeetings = allMeetingsCopy.filter(meeting =>{
        let meetingDate = new Date(meeting.startTime)

        return (
            today.isAfter(meetingDate) && 
            (meeting?.collector == userspace.uid && ((meeting.status === Meetings.MeetingStatus.meetingEnded) || (meeting.status === Meetings.MeetingStatus.payerConfirmed))) ||
            (meeting?.payer == userspace.uid && ((meeting.status === Meetings.MeetingStatus.meetingEnded) || (meeting.status === Meetings.MeetingStatus.collectorConfirmed)))
        )
    })
    timeSortMeetings(confirmableMeetings)

    return confirmableMeetings.splice(0,3)
})

const awaitingRescheduleMeetings = computed(()=>{
    let awaitingRescheduleMeetings: DataInstance<Meetings.Model>[] = []
    let today = moment(Date.now())

    let allMeetingsCopy = [...allMeetings.value]
    awaitingRescheduleMeetings = allMeetingsCopy.filter(meeting =>{

        return (
            (meeting?.payer == userspace.uid && meeting.status === Meetings.MeetingStatus.rescheduleRequested)
        )
    })
    timeSortMeetings(awaitingRescheduleMeetings)

    return awaitingRescheduleMeetings.splice(0,3)
})

//Helper function for sorting the meetings lists
const timeSortMeetings = (meetingInstanceArray: DataInstance<Meetings.Model>[] ) => {
    meetingInstanceArray.sort((a, b)=>{
        let startA = new Date(a.startTime)
        let startB = new Date(b.startTime)
        if(startA < startB)
            return -1
        else if(startA > startB)
            return 1
        else
            return 0
    })
}



const handlePopup = (value: DataInstance<Meetings.Model>) =>{
    selectedMeeting.value = value
    showPopup.value = true
}
const closePopup = ()=>{
    showPopup.value = false
    showConfirm.value = false
    selectedMeeting.value = null
}


const __returned__ = { moment, selectedMeeting, showConfirm, showPopup, noScroll, router, goTo, allMeetings, invites, allInvites, showWelcome, showFirstInvite, userspace, user, balance, scheduledCount, heldCount, currentMeetings, failingPaymentMeetings, scheduledMeetings, payerConfirmableMeetings, confirmableMeetings, awaitingRescheduleMeetings, timeSortMeetings, handlePopup, closePopup, UpcomingMeeting, Loader, useRouter, onBeforeMount, onMounted, ref, computed, Meetings, FinancialUserspaces, InviteLinks, query, where, meetingPopup, changeMeeting, DataInstance, useUserspace, useInvites, useMeetings }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})